import FieldTypes from "../../Types/FieldTypes"

const buildTemplateWithoutConfig = {
    /* A function that takes an array of FieldTypes and returns an array of arrays of FieldTypes. */
    buildTemplate: (schema: Array<FieldTypes>) => {
        let template = []
        for (let i = 0; i < schema.length; i++) {
            template.push([schema[i]])
        }
        return template
    }
}
export default buildTemplateWithoutConfig